import React, { Dispatch, SetStateAction } from "react";

import { setLocalStorageShowFieldRecommendations, useTranslation } from "utils";

import { Flex, Switch } from "components";

type RecommendationSwitchProps = {
  showRecommendations: boolean;
  setShowRecommendations: Dispatch<SetStateAction<boolean>>;
  isFetchingCropRecommendations: boolean;
};

export const RecommendationSwitch = ({ showRecommendations, setShowRecommendations, isFetchingCropRecommendations }: RecommendationSwitchProps) => {
  const { t } = useTranslation(["fieldTimeline"]);

  const handleRecommendationsSwitch = (checked: boolean) => {
    setLocalStorageShowFieldRecommendations(checked);
    setShowRecommendations(checked);
  };

  return (
    <Flex className="recommendation-toggle" align="center" gap="0.625rem">
      <span className="recommendation-toggle-text">{t("header.recommendationSwitchText")}</span>
      <Switch
        className="recommendation-toggle-switch"
        data-testid="recommendation-toggle"
        checked={showRecommendations}
        onChange={handleRecommendationsSwitch}
        disabled={isFetchingCropRecommendations}
      />
    </Flex>
  );
};
